module.exports = __webpack_public_path__ + "static/media/img_57.fd2b42c0.png";